import { render, staticRenderFns } from "./vegdetail.vue?vue&type=template&id=1058c439&scoped=true&"
import script from "./vegdetail.vue?vue&type=script&lang=js&"
export * from "./vegdetail.vue?vue&type=script&lang=js&"
import style0 from "./vegdetail.vue?vue&type=style&index=0&id=1058c439&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1058c439",
  null
  
)

export default component.exports